import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useNavigate } from "react-router-dom";
//st
export default function BookingOrClassCancellation({ notification }) {
  const [club, setClub] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const navi = useNavigate();

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const clubResponse = await axios.get(
        `${ApiConnectionString}/api/club/${notification.clubId}`
      );

      if (clubResponse.status === 200) {
        setClub(clubResponse.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setClub(null); // Set club to null if there's an error
    } finally {
      setIsLoading(false); // Stop loading state in any case
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    if (club) {
      return (
        <div className="container bg-white">
          <div className="blueBanner">
            <p className="fw-bold p-2">Cancellation</p>
          </div>

          <div>
            <p
              onClick={() => navi(`/club/${club.id}`)}
              className="fw-bold red-text pointer text-center"
            >
              {club.name}
            </p>
            <div
              onClick={() => navi(`/club/${club.id}`)}
              className="circle-crop mx-auto"
            >
              <img
                src={
                  club.image
                    ? `${ApiConnectionString}/api/ClubProfileImage/${club.id}`
                    : NoImagePlaceholder
                }
                alt="Club Image"
                className="mt-0 pointer"
              />{" "}
            </div>
            <p className="m-2">{notification.content}</p>
          </div>
        </div>
      );
    } else {
      return (
        <div className="container bg-white">
          <div className="blueBanner">
            <p className="fw-bold p-2">Cancellation</p>
          </div>

          <p>Not found</p>
        </div>
      );
    }
  }
}
